module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_0.e2ac6460.png";